import { Component } from "@opten/compiler/metadata/component";
import { OnInit } from "@opten/compiler/metadata/lifecycle";
import { addClass } from "@opten/dom/add-class";
import { removeClass } from "@opten/dom/remove-class";


@Component({ className: 'js-search-autocomplete' })
export class SearchAutocompleteComponent implements OnInit {
	private searchField: HTMLInputElement;
	private searchSectionField: HTMLInputElement;
	private searchForm: HTMLFormElement;


	private autocompleteList: HTMLElement;
	private currentFocus = -1;
	private autocompleteListItems: Element[] = [];
	private autocompleteSections: Element[] = [];


	constructor(private element: HTMLElement) { }
	onInit(): void {
		this.searchField = this.element.getElementsByClassName('js-search-autocomplete-field')[0] as HTMLInputElement;
		this.searchForm = this.element.getElementsByClassName('js-search-autocomplete-form')[0] as HTMLFormElement;
		this.autocompleteList = this.element.getElementsByClassName('js-search-autocomplete-list')[0] as HTMLElement;
		const autocompleteSections = this.element.getElementsByClassName('js-search-autocomplete-sections');
		const searchSectionFields = this.element.getElementsByClassName('js-search-autocomplete-section-field');

		if (autocompleteSections && autocompleteSections.length > 0 && searchSectionFields && searchSectionFields.length > 0) {
			this.autocompleteSections = Array.from(autocompleteSections[0].getElementsByClassName('js-search-autocomplete-section'));
			this.searchSectionField = searchSectionFields[0] as HTMLInputElement;

			if (this.autocompleteSections && this.autocompleteSections.length > 0) {
				this.autocompleteSections.forEach(item => item.addEventListener('click', () => this.handleAutocompleteSectionClicked(item as HTMLElement)));
			}
		}
		if (this.searchField) {
			this.searchField.addEventListener('input', (e) => this._handleSearchFieldInput(e));
			this.searchField.addEventListener('keydown', (e) => this.handleSearchFieldKeyDown(e));
		}
	}

	private _handleSearchFieldInput(e: Event) {
		this.cleanAutocompleteList();
		let value = this.searchField.value;
		if (value && value.length > 0) {
			fetch('/umbraco/surface/searchsurface/AutocompleteSearchTerm', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					// todo: set language from chooser in the future
					'accept-language': 'de-CH',
					// todo: why? if we change to a api controller we don't have this problem...
					'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
				},
				body: "term=" + value
			})
				.then(response => {
					const contentType = response.headers.get('content-type');
					if (contentType && contentType.includes('text/html')) {
						return response.text();
					}
				})
				.then(data => {
					this.cleanAutocompleteList();
					if (data != null && data.length > 0) {
						this.autocompleteList.innerHTML = data;

						this.autocompleteListItems = Array.from(this.autocompleteList.getElementsByClassName('js-search-autocomplete-list-item'));
						if (this.autocompleteListItems && this.autocompleteListItems.length > 0) {
							this.autocompleteListItems.forEach(item => item.addEventListener('click', () => this.handleAutocompleteListItemClicked(item as HTMLElement)));
							addClass(this.autocompleteList, 'is-visible');
						}
					}
				});
		}
	}

	private handleSearchFieldKeyDown(e: KeyboardEvent) {
		if (this.autocompleteListItems && this.autocompleteListItems.length > 0) {
			if (e.keyCode == 40) {
				/*If the arrow DOWN key is pressed,
				increase the currentFocus variable:*/
				this.currentFocus++;
				/*and and make the current item more visible:*/
				this.setAutocompleteListElementActive();
			} else if (e.keyCode == 38) { //up
				/*If the arrow UP key is pressed,
				decrease the currentFocus variable:*/
				this.currentFocus--;
				/*and and make the current item more visible:*/
				this.setAutocompleteListElementActive();
			} else if (e.keyCode == 13) {
				/*If the ENTER key is pressed, prevent the form from being submitted,*/
				if (this.currentFocus > -1) {
					e.preventDefault();
					/*and simulate a click on the "active" item:*/
					this.autocompleteListItems[this.currentFocus].dispatchEvent(new Event('click'));
				}
			}
		}
	}
	private setAutocompleteListElementActive() {
		this.autocompleteListItems.forEach(o => removeClass(o, 'is-active'));
		addClass(this.autocompleteListItems[this.currentFocus], 'is-active');
	}

	private handleAutocompleteListItemClicked(item: HTMLElement) {
		const itemInput = item.getElementsByTagName('input')[0] as HTMLInputElement;
		this.searchField.value = itemInput.value;
		this.searchForm.submit();
	}

	private handleAutocompleteSectionClicked(item: HTMLElement): void {
		const itemInput = item.getElementsByTagName('input')[0] as HTMLInputElement;
		this.searchSectionField.value = itemInput.value;
		this.searchForm.submit();
	}

	private cleanAutocompleteList() {
		removeClass(this.autocompleteList, 'is-visible');
		this.autocompleteList.innerHTML = '';
		this.currentFocus = -1;
		this.autocompleteListItems = [];

	}
}
